module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'absence',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '75px',
        },
        rowActions: {
            edit: true,
            customs: [
                {
                    buttonType: 'delete',
                    neutral: true,
                    privilegeCode: 'bo_absence:delete'
                },
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_absence': true,
            'resourceChanged.bo_employees': true,
            'resourceChanged.bo_contractors': true,
        }
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'absenceID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true, privilegeCode: 'bo_absence:create', }
                ]
            }
        },
    },
}